import React, { useState, useMemo, useCallback, useEffect } from "react";
import { useAppContext } from "../../../Context/AppContext";
import { useNavigate } from "react-router-dom";
import CustomTooltip from "../../../CustomTooltip";
import BlockHeader from "../../../Common/BlockHeader/BlockHeader";
import CassettaCollocazione from "./CassettaCollocazione";
import MovimentazioneCollocazione from "./MovimentazioneCollocazione";
import EsposizioneCollocazione from "./EsposizioneCollocazione";
import "./CollocazioneSection.scss";

const CollocazioneSection = ({
  repertoData,
  disabled,
  handleFieldChange,
  onRaccoltaChange,
}) => {

  const navigate = useNavigate();
  const { setCassettaId } = useAppContext();
  const [isCassetta, setIsCassetta] = useState(true);


  const isOut = useMemo(
    () => typeof repertoData.movimentazione === "object"  && repertoData.movimentazione !== null,
    [repertoData]
  );


  const toggleCollocazione = useCallback(() => {
    setIsCassetta((prev) => !prev);
  }, []);

  useEffect(() => {
    if(repertoData.esposizione !== null) {
      setIsCassetta(false);
    }
    if(repertoData.raccolta !== null) {
      setIsCassetta(true);
    }
  }, [repertoData]);

  const tipoValue = useMemo(() => {
    if( isCassetta) {
      return isOut ? "In deposito (temporaneamente fuori sede)" : "In deposito";
    } else {
      return isOut ? "In esposizione (temporaneamente fuori sede)" : "In esposizione";
    }
  }, [isOut, isCassetta]);

  const handleCassetaNavigate = () => {
    setCassettaId(repertoData["raccolta"]?.cassettaId);
    navigate("/cassette/view");
  };

  const renderCollocazione = () => {
    console.log(">>> repertoData: ", repertoData);
    console.log(">>> isOut: ", isOut);

    if (isCassetta) {
      return (
        <CassettaCollocazione
          disabled={isOut || disabled}
          tipoValue={tipoValue}
          repertoData={repertoData}
          handleCassetaNavigate={handleCassetaNavigate}
          handleFieldChange={handleFieldChange}
        />
      );
    } else {
      return (
        <EsposizioneCollocazione
          repertoData={repertoData}
          disabled={isOut || disabled}
          handleFieldChange={handleFieldChange}
        />
      );
    };
  };

  return (
    <React.Fragment>
      <BlockHeader title="COLLOCAZIONE">
        <CustomTooltip text="Modifica collocazione">
          <button
            disabled={disabled || isOut}
            className="toggle-cassetta-button"
            onClick={toggleCollocazione}
          >
            { isCassetta ? "Metti in esposizione" : "Metti in cassetta"}
          </button>
        </CustomTooltip>
      </BlockHeader>
      <div className="tipo-collocazione-container">
        <p className= "tipo-collocazione-text"> Tipo collocazione:</p >
        <p className={`tipo-collocazione-value ${isOut ? "tipo-collocazione-value-out" : "tipo-collocazione-value"}`}>{tipoValue}</p>
      </div>
      {renderCollocazione()}
    </React.Fragment>
  );
};

export default CollocazioneSection;
